<template>
  <v-dialog v-model="dialog" width="800" max-height="696">
    <div class="back-white">
      <v-row class="ma-0  align-center text-center momo-role mb-5 back-556C96">
        <h3 class="color-white ml-5">메모</h3>
        <v-spacer />
      </v-row>
      <v-row calss="ma-0  justify-center d-flex align-center text-center">
        <v-simple-table class="pa-5" height="500" fixed-header>
          <tbody>
            <tr v-for="(memo, index) in memoList" :key="index">
              <td class="memo-header-text ma-0 pa-0" style="width:220px;">
                [ {{ typeChange(memo.type) }} - {{ memo.roleType }} ]
              </td>
              <td style="width:500px;">{{ memo.memo }}</td>
              <td style="width:120px;">
                {{ memo.regDate | moment("YYYY-MM-DD") }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-row class="justify-center mt-5 pb-5">
        <v-btn
          width="140"
          height="38"
          color="#2457A8"
          class="text-color ml-5 font-size-14"
          rounded
          @click="dialog = !dialog"
          >확인
        </v-btn>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import InvoiceApi from "@/api/InvoiceService";
import OrderApi from "@/api/OrderService";
import OrderInvoiceApi from "@/api/OrderInvoiceService";
import ApprovalApi from "@/api/ApprovalService";
export default {
  name: "memoList",
  data: () => ({
    inputData: "",
    dialog: false,
    list: "",
    status: false,
    orderInvoiceList: [],
    state: "",
    memoList: [],
  }),

  watch: {
    dialog(state) {
      if (!state) {
        this.inputData = "";
        let status;
        if (this.state == "invoice") status = "invoiceNavigationDuplicated";
        else if (this.state == "order") status = "orderNavigationDuplicated";
        else if (this.state == "orderInvoice")
          status = "orderInvoiceNavigationDuplicated";
        this.$bus.$emit(status);
      }
    },
  },

  created() {
    this.$bus.$on("memoListOn", async (data, state) => {
      this.memoStart(data, state);
    });
  },
  beforeDestroy() {
    this.$bus.$off("memoListOn");
  },
  methods: {
    async memoStart(data, state) {
      this.state = state;
      this.status = false;
      let payload;
      if (state == "order") {
        payload = { orderId: data, orderType: 1 };
      } else if (state == "invoice") {
        payload = { invoiceId: data };
      } else {
        payload = { orderId: data, orderType: 0 };
      }
      let res = await ApprovalApi.approvalMemoList(payload);
      this.memoList = res.data.list;
      this.dialog = true;
    },
    async restoreText() {
      if (this.list.state == "invoice") {
        await InvoiceApi.invoiceWriteMemo({
          memo: this.inputData,
          invoiceId: this.list.invoiceId,
        });
      } else if (this.list.state == "order") {
        await OrderApi.orderWriteMemo({
          memo: this.inputData,
          orderId: this.list.orderId,
        });
      } else if (this.list.state == "orderInvoice") {
        await OrderInvoiceApi.orderinvoiceChangeMemo({
          memo: this.orderInvoiceList,
        });
      }
      this.dialog = false;
    },

    typeChange(type) {
      let returnText = [
        "승인요청",
        "수정요청",
        "미출고",
        "일부출고",
        "출고완료",
        "입고완료",
        "승인처리",
        "수정처리",
      ];
      return returnText[type - 1];
    },
  },
};
</script>

<style scoped>
.memo-header-text {
  color: #333;
  font-size: 18px;
  font-family: Noto Sans KR;
  font-weight: 700;
}
.font-size-14 {
  font-size: 14px !important ;
}

.momo-role {
  background: #c4c4c4;
  height: 60px;
}
.width-500 {
  width: 600px;
  word-break: break-all;
}
.width-height {
  width: 1000px;
  height: 400px;
  word-break: break-all;
}

.text-color {
  color: white !important;
  font-size: 18px;
}

.row {
  margin: 0px;
}

.v-text-field__details {
  height: 0px !important;
}

.resize-none {
  resize: none;
}

.ml-80 {
  margin-left: 80px;
}

.border {
  border: thin solid gray;
  border-radius: 5px;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
}
</style>
